"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
const util_1 = require("../services/util");
class CustomFieldType extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'customFieldType';
        this._name = initParams.name;
        this._icon = initParams.icon;
        this._fieldType = initParams.field_type;
        this._colour = initParams.colour;
        this.__permission = initParams._permission;
    }
    set name(value) {
        console.error('Do not set objects this way');
    }
    setName(value) {
        return this.dataService.updateCustomFieldType(this.id, { name: value }, this);
    }
    get name() {
        return this._name;
    }
    set icon(value) {
        console.error('Do not set objects this way');
    }
    setIcon(value) {
        return this.dataService.updateCustomFieldType(this.id, { icon: value }, this);
    }
    get icon() {
        return this._icon;
    }
    set fieldType(value) {
        console.error('Do not set objects this way');
    }
    setFieldType(value) {
        return this.dataService.updateCustomFieldType(this.id, { field_type: value }, this);
    }
    get fieldType() {
        return this._fieldType;
    }
    set colour(value) {
        console.error('Do not set objects this way');
    }
    setColour(value) {
        return this.dataService.updateCustomFieldType(this.id, { colour: value }, this);
    }
    get colour() {
        return this._colour;
    }
    set _permission(value) {
        console.error('Do not set objects this way');
    }
    set_permission(value) {
        return this.dataService.updateCustomFieldType(this.id, { _permission: value }, this);
    }
    get _permission() {
        return this.__permission;
    }
    set(object) {
        let updateObject = (0, util_1.snakeObject)(object);
        let self = this;
        return this.dataService.updateCustomFieldType(this.id, updateObject, this)
            .then(function (res) {
            Object.keys(object).forEach(function (key) {
                self['_' + key] = object[key];
            });
            return Promise.resolve(res);
        });
    }
    delete() {
        return this.dataService.deleteCustomFieldType(this.id, this);
    }
}
exports.default = CustomFieldType;
//# sourceMappingURL=customFieldType.js.map